import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const CarouselDescription = (props) => {
  const { cardsCount } = props
  const { t } = useTranslation()
  return (
    
    <div className="info-card-description">
      <div className="info-card-description-text">
        <p>{t('Recommendations.campaign.setup.carouselAd.description.cardsCount', { count: cardsCount })}</p>
        <div className="dot-divider" />
        <p>{t('Recommendations.campaign.setup.carouselAd.description.cardsDrag')}</p>
      </div>

      <div className="info-card-description-states">
        <p className="info-card-description-state ready">{t('Recommendations.campaign.setup.carouselAd.description.states.ready')}</p>

        <p className="info-card-description-state partial">{t('Recommendations.campaign.setup.carouselAd.description.states.partial')}</p>
        
        <p className="info-card-description-state missing">{t('Recommendations.campaign.setup.carouselAd.description.states.missing')}</p>
      </div>
    </div>
  )
}

CarouselDescription.propTypes = {
  cardsCount: PropTypes.number.isRequired,
}

export default CarouselDescription